import {
    getDefaultExplanationObjective,
    getDefaultName,
    getDefaultTimePeriod,
    getDefaultTimelineObjective,
} from '../../../../../components/CycleCreate/services';

import { getTimelineMode } from '../../../../../components/CycleCreate/services/Scope';
import { getCurrentUser } from '../../../../../services/CurrentUser';
import { isFeatureEnabled } from '../../../../../services/Features';
import { EVERYONE_PROCESS } from '../../constants/process';

export function getCreateModel(allUsers) {
    const currentUser = getCurrentUser();
    const timeline = getDefaultTimelineObjective(currentUser);
    const isCascadingObjectivesEnabled = isFeatureEnabled('FEATURE_objectiveCascading');

    return {
        allUsers,
        cycleAdmins: [],
        allowedUsers: [],
        name: getDefaultName('objective'),
        explanation: getDefaultExplanationObjective(),
        timePeriod: {
            from: getDefaultTimePeriod().start,
            to: getDefaultTimePeriod().end,
        },
        timeline: timeline,
        disabledDates: {
            statusEditableByOwnerUntil: true,
            statusEditableByManagerUntil: true,
        },
        process: EVERYONE_PROCESS,
        options: {
            icon: true,
            cascadingObjectives: isCascadingObjectivesEnabled,
            keyResults: true,
            status: false, // Completion status
            completionPercentage: false,
            weighting: false,
            categories: {
                enabled: false,
                values: null,
            },
            ratings: {
                enabled: false,
                values: null,
            },
            defaultVisibility: isCascadingObjectivesEnabled ? 'public' : 'protected', // protected | public
            allowEmployeesToChangeVisibility: true,
            allowPrivateObjectives: true,
            allowEmployeesToShareWithSpecificPeople: true,
            sendAutomaticReminders: false,
        },
        timelineMode: getTimelineMode(timeline),
    };
}

export function getEditModel(model) {
    return {
        ...model,
        disabledDates: {},
        timelineMode: getTimelineMode(model.timeline),
    };
}

export function getCopyModel(model) {
    return {
        ...model,
        name: `Copy of ${model.name}`,
        disabledDates: {},
        options: {
            ...model.options,
            keyResults: true,
        },
        timelineMode: getTimelineMode(model.timeline),
    };
}
